<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end" v-if="is_admin">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-tabs
                    v-if="allow_reexam_marks_entry"
                    v-model="tabs"
                    @change="onload"
                    background-color="brand"
                    dark
                    grow
                    slider-color="yellow"
                    class="rounded-xl custom-tabs"
                >
                    <v-tab> Regular Marks Entry </v-tab>

                    <v-tab> Reexam Marks Entry </v-tab>
                </v-tabs>
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title v-if="tabs == 0">
                            <strong> Teacher Marks Entry </strong>
                        </v-toolbar-title>
                        <v-toolbar-title v-else>
                            <strong> Teacher Reexam Marks Entry </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                            <v-autocomplete
                                dense
                                required
                                outlined
                                rounded
                                color="#0F2027"
                                v-model="ay"
                                :items="ay_list"
                                item-text="ay"
                                item-value="id"
                                label="Academic Year"
                                persistent-hint
                                hint="Please select academic year"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                            <v-autocomplete
                                dense
                                required
                                outlined
                                rounded
                                color="#0F2027"
                                v-model="sem"
                                :items="semester_list"
                                item-text="name"
                                item-value="id"
                                label="Semester"
                                persistent-hint
                                hint="Please select semester"
                            />
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 m-0" v-if="ay != null && sem != null">
                            <v-btn class="button" :loading="loader" @click="getInstCourse">Proceed</v-btn>
                        </v-col>
                    </v-row>

                    <span v-if="instrructor_course_list != ''">
                        <!-- excel export btn code -->

                        <v-col cols="12" sm="12" md="12">
                            <v-btn color="success" outlined rounded>
                                <download-excel
                                    class="mr-2 pb-3 pt-2"
                                    :data="instrructor_course_list"
                                    :fields="table_fields"
                                    worksheet="MarksEntry"
                                    name="MarksEntry.xls"
                                >
                                    <v-icon dark>mdi-file-excel</v-icon> Export
                                </download-excel>
                            </v-btn>
                        </v-col>
                        <!-- excel export btn code end -->

                        <v-data-table
                            v-if="instrructor_course_list.length > 0"
                            dense
                            :headers="headers1"
                            :items="instrructor_course_list"
                            :search="search"
                            class="elevation-1 mytable"
                        >
                            <template v-slot:item.crs_off_learner="{ item }">
                                <v-btn class="btn-css btn" @click="get_learners(item.crs_off_learner)"
                                    >{{ item.crs_off_learner.length }}</v-btn
                                >
                            </template>
                            <template v-slot:item.options="{ item }">
                                <v-btn
                                    class="button"
                                    @click="
                  getscheme_info(
                    item.courseassessmentscheme_id,
                    item.crs_off_id,
                    item.crs_off_learner,
                    item.divisionoffering_id,
                    item.crs_id,
                    item.grade_details
                  )
                "
                                >
                                    Proceed
                                </v-btn>
                            </template>
                        </v-data-table>
                    </span>

                    <span v-if="ass_scheme_deatils_list != ''">
                        <v-dialog v-model="dialog_scheme" persistent max-width="1200px">
                            <v-card>
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong> Course scheme details </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <v-col cols="12" sm="12" md="12">
                                    <v-card class="box">
                                        <v-data-table
                                            v-if="
                      ass_scheme_deatils_list != '' &&
                      ass_scheme_deatils_list != 'No Scheme'
                    "
                                            dense
                                            :headers="headers2"
                                            :items="ass_scheme_deatils_list"
                                            class="elevation-1 mytable"
                                        >
                                            <template v-slot:item.options="{ item }">
                                                <v-btn
                                                    x-small
                                                    class="button"
                                                    @click="
                          assesmentschememarkentry(
                            item.ass_det_id,
                            item.courseoffering_id,
                            item.courseAssessmentScheme
                          );
                          dialog_marks_entry = true;
                        "
                                                >
                                                    Proceed
                                                </v-btn>
                                                <v-btn
                                                    x-small
                                                    v-if="tabs == 0"
                                                    class="button"
                                                    @click="
                          assesmentschememarkentry(
                            item.ass_det_id,
                            item.courseoffering_id,
                            item.courseAssessmentScheme
                          );
                          dialog_marks_entry_import = true;
                        "
                                                >
                                                    Import Marks Entry
                                                </v-btn>
                                                <v-btn
                                                    x-small
                                                    class="button"
                                                    @click="deletemarkentry(
                                                    item.ass_det_id,
                                                    item.courseoffering_id,
                                                    item.courseAssessmentScheme)"
                                                >
                                                    Delete Marks Entry
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                                <v-row justify="center">
                                    <v-btn rounded class="button" @click="dialog_scheme = false">Close</v-btn>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </span>
                    <v-dialog fullscreen v-model="dialog_marks_entry" persistent max-width="1200px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Teacher Marks Entry </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn small rounded @click="dialog_marks_entry = false">Close</v-btn>
                            </v-toolbar>
                            <span v-if="rubricsScheme == 'NO'">
                                <span v-if="scheme_details != ''">
                                    <span v-if="grading_mark_entry == 'YES'">
                                        <span v-if="mark_entry_type == 'Marking'">
                                            <marks-entry-without-rubrics
                                                :scheme_details="scheme_details"
                                                :tabs="tabs"
                                                :allow_reexam_marks_entry="allow_reexam_marks_entry"
                                            ></marks-entry-without-rubrics>
                                        </span>
                                        <span v-else>
                                            <marks-entry-grading
                                                :scheme_details="scheme_details"
                                                :grade_details="grade_details"
                                                :remarks_list="remarks_list"
                                                :tabs="tabs"
                                                :allow_reexam_marks_entry="allow_reexam_marks_entry"
                                            ></marks-entry-grading>
                                        </span>
                                    </span>
                                    <span v-else>
                                        <marks-entry-without-rubrics
                                            :scheme_details="scheme_details"
                                            :tabs="tabs"
                                            :allow_reexam_marks_entry="allow_reexam_marks_entry"
                                        ></marks-entry-without-rubrics>
                                    </span>
                                </span>
                            </span>
                            <span v-if="rubricsScheme == 'YES'">
                                <marks-entry-rubrics
                                    :rubric_list="rubric_list"
                                    :tabs="tabs"
                                    :allow_reexam_marks_entry="allow_reexam_marks_entry"
                                    :scheme_details="scheme_details"
                                ></marks-entry-rubrics>
                            </span>
                            <center>
                                <v-btn rounded class="button" @click="dialog_marks_entry = false">Close</v-btn>
                            </center>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog_marks_entry_import" persistent max-width="1500px">
                        <v-card>
                            <v-col cols="12" sm="12" md="12">
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong> Import Marks Entry </strong>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn small rounded @click="dialog_marks_entry_import = false">Close</v-btn>
                                </v-toolbar>
                                <v-row justify="center">
                                    <v-col lg="5" sm="6" md="6" cols="6">
                                        <v-avatar color="#E8EAF6"> 1</v-avatar>
                                        <span
                                            style="
                                                margin-left: 10px;
                                                font-size: 15px;
                                                color: blue;
                                                text-decoration: underline;
                                                cursor: pointer;
                                            "
                                            @click="exportTableToCSV(`${scheme_details[0].standard}_${scheme_details[0].division}_${scheme_details[0].crs_name}_${scheme_details[0].assessmenttype}.csv`)"
                                        >
                                            Download CSV / Excel Upload Template
                                            <v-icon>mdi-download</v-icon>
                                        </span></v-col
                                    >
                                    <v-col lg="3" sm="6" md="6">
                                        <v-avatar color="#E8EAF6"> 2</v-avatar>
                                        <span style="margin-left: 10px; font-size: 15px"
                                            >Prepare Excel File</span
                                        > </v-col
                                    ><v-col lg="3" sm="6" md="6">
                                        <v-avatar color="#E8EAF6"> 3</v-avatar>
                                        <span style="margin-left: 10px; font-size: 15px">Start Upload</span>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="12" sm="4" md="4">
                                        <v-file-input
                                            density="compact"
                                            variant="outlined"
                                            label="Select File"
                                            v-model="file"
                                            accept=".csv"
                                            show-size
                                            :rules="[(v) => !!v || 'File Required']"
                                        ></v-file-input>
                                        <template #label>
                                            <p>Select File<span style="color: red">*</span></p>
                                        </template>
                                    </v-col>
                                    <v-col cols="12" sm="12" align="center">
                                        <v-btn
                                            class="button"
                                            @click="importMarksEntry()"
                                            :disabled="!file"
                                            :loading="uploading"
                                        >
                                            UPLOAD
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row justify="center" class="mt-5 mb-5 ml-5 mr-5 yellow-card">
                                    <v-col cols="12" sm="12" md="12">
                                        <b>Guidelines</b>
                                        <ol style="line-height: 30px">
                                            <li>The file must be in <strong>CSV</strong> format.</li>

                                            <li>
                                                The first row of the file must contain the header labels. EduplusSchool
                                                uses these headers to map the data correctly and ensure a successful
                                                import.
                                            </li>

                                            <li>
                                                Each row must contain valid marks. Marks must be a positive number and
                                                must not exceed the maximum marks for the respective exam or assessment.
                                            </li>

                                            <li>
                                                If a student is absent, enter <strong>AB</strong> in the
                                                <strong>Absent/Medical Leave</strong> column and enter
                                                <strong>0</strong> as the marks.
                                            </li>

                                            <li>
                                                If a student is on medical leave, enter <strong>ML</strong> in the
                                                <strong>Absent/Medical Leave</strong> column and enter
                                                <strong>0</strong> as the marks.
                                            </li>

                                            <li>
                                                By default, the <strong>Absent/Medical Leave</strong> column contains
                                                <strong>P</strong>, which indicates that the student was present for the
                                                examination.
                                            </li>
                                        </ol>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-toolbar v-if="statuslist!=''" class="toolbar no-display" flat dense>
                                        <v-toolbar-title>
                                            <strong> Failed List </strong>
                                        </v-toolbar-title>
                                    </v-toolbar>
                                    <br />
                                    <v-data-table
                                        v-if="statuslist!=''"
                                        :headers="headers5"
                                        :items="statuslist"
                                        sort-by
                                        class="elevation-1 mytable"
                                        dense
                                        :search="search"
                                        :loading="output_load"
                                    ></v-data-table>
                                    <br />
                                    <v-toolbar v-if="success_list!=''" class="toolbar no-display" flat dense>
                                        <v-toolbar-title>
                                            <strong> Success List </strong>
                                        </v-toolbar-title>
                                    </v-toolbar>
                                    <br />
                                    <v-data-table
                                        v-if="success_list!=''"
                                        :headers="headers5"
                                        :items="success_list"
                                        sort-by
                                        class="elevation-1 mytable"
                                        dense
                                        :search="search"
                                        :loading="output_load"
                                    ></v-data-table>
                                </v-col>
                                <span v-if="rubricsScheme == 'NO'">
                                    <table id="example" style="display: none; font-weight: bold">
                                        <thead>
                                            <tr>
                                                <th class="mdl-data-table__cell--non-numeric">Academic Year</th>
                                                <th class="mdl-data-table__cell--non-numeric">Standard</th>
                                                <th class="mdl-data-table__cell--non-numeric">Division</th>
                                                <th class="mdl-data-table__cell--non-numeric">PRN No.</th>
                                                <th class="mdl-data-table__cell--non-numeric">Roll No.</th>
                                                <th class="mdl-data-table__cell--non-numeric">Name</th>
                                                <th class="mdl-data-table__cell--non-numeric">
                                                    Absent/Medical Leave(AB/ML)
                                                </th>
                                                <th class="mdl-data-table__cell--non-numeric">
                                                    Marks({{ scheme_details[0].evaluated_marks }})
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item,index in scheme_details[0].learners" :key="index">
                                                <td>{{ item.academicyear }}</td>
                                                <td>{{ item.std }}</td>
                                                <td>{{ item.div }}</td>
                                                <td>{{ item.registration_number }}</td>
                                                <td>{{ item.rollno }}</td>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.present_status }}</td>
                                                <td>{{ item.evaluated_marks }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </span>
                                <span v-if="rubricsScheme == 'YES'">
                                    <table id="example1" style="display: none; font-weight: bold">
                                        <thead>
                                            <tr>
                                                <th class="mdl-data-table__cell--non-numeric">Academic Year</th>
                                                <th class="mdl-data-table__cell--non-numeric">Standard</th>
                                                <th class="mdl-data-table__cell--non-numeric">Division</th>
                                                <th class="mdl-data-table__cell--non-numeric">PRN No.</th>
                                                <th class="mdl-data-table__cell--non-numeric">Roll No.</th>
                                                <th class="mdl-data-table__cell--non-numeric">Name</th>
                                                <th class="mdl-data-table__cell--non-numeric">
                                                    Absent/Medical Leave(AB/ML)
                                                </th>
                                                <th class="" v-for="item in rubric_list" :key="item.rubricsscheme_id">
                                                    <center>
                                                        {{ item.rubricsscheme }} ({{ item.rubricsscheme_marks}})
                                                    </center>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="s in scheme_details[0].learners" :key="s.id">
                                                <td>{{s.academicyear}}</td>
                                                <td>{{s.std}}</td>
                                                <td>{{s.div}}</td>
                                                <td>{{s.registration_number}}</td>
                                                <td>{{s.rollno}}</td>
                                                <td>{{s.name}}</td>
                                                <td>{{ s.present_status }}</td>
                                                <td v-for="item1 in s.rubric_list" :key="item1.rubricsscheme_id">
                                                    <span v-for="k in rubric_list" :key="k.rubricsscheme_id">
                                                        <span v-if="k.rubricsscheme_id == item1.rubricsscheme_id">
                                                            {{item1.maxmarks}}
                                                        </span>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </span>
                                <center>
                                    <v-btn rounded class="button" @click="dialog_marks_entry_import = false"
                                        >Close</v-btn
                                    >
                                </center>
                            </v-col>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog" persistent max-width="1200px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Course Learners </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-card class="box" v-if="learners != ''">
                                    <v-row class="p-0 m-0" v-if="learners.length > 0">
                                        <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                                            <v-text-field
                                                class="search"
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search in table"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-data-table
                                        v-if="learners.length > 0"
                                        dense
                                        :headers="headers"
                                        :items="learners"
                                        :search="search"
                                        class="elevation-1 mytable"
                                    >
                                    </v-data-table>
                                </v-card>
                            </v-col>
                            <v-row justify="center">
                                <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-card>
        </v-col>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Mark Entry Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/EcrDc658umo?si=Z3y-FNRf75CCpCD8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import MarksEntryWithoutRubrics from "./MarksEntryWithoutRubrics";
    import MarksEntryRubrics from "./MarksEntryRubrics";
    import MarkEntryWithGrading from "./MarkEntryWithGrading";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            "marks-entry-without-rubrics": MarksEntryWithoutRubrics,
            "marks-entry-rubrics": MarksEntryRubrics,
            "marks-entry-grading": MarkEntryWithGrading,
            Breadcrumbs,
        },
        data() {
            return {
                is_admin: false,
                uploading: false,
                videoDialog:false,
                file: null,
                snackbar_msg: null,
                snackbar: false,
                loader: false,
                color: "",
                ay_list: [],
                ay: null,
                tabs: 0,
                //   extraBreadcrumbItems: [

                //   ],
                //   breadcrumbClass: "breadcrumb-style1",
                semester_list: [],
                sem: null,
                search: null,
                dialog: false,
                dialog_scheme: false,
                dialog_marks_entry_import: false,
                dialog_marks_entry: false,
                rubricsScheme: null,
                instrructor_course_list: [],
                ass_scheme_deatils_list: [],
                learners: [],
                crs_off_learner: [],
                scheme_details: [],
                grading_mark_entry: null,
                divisionoffering_id: null,
                crs_inst_id: null,
                rubric_list: [],
                org_id: null,
                mark_entry_type: null,
                grade_details: [],
                remarks_list: [],
                allow_reexam_marks_entry: null,
                table_fields: {
                    "Sr. No": "srno",
                    "Academic Year": "academicyear",
                    Semester: "semester",
                    "Course ": "crs_name",
                    Standard: "standard",
                    Division: "divisionoffering",

                    Student: "crs_off_learner.length",
                    "Mark Entry Type": "coursemarksentrytype",
                    "Course Type": "coursetype",
                    "Grading Scheme": "gradingscheme",
                    "Assessment Scheme": "courseassessmentscheme",
                },
                success_list: [],
                statuslist: [],
                headers5: [
                    { text: "Sr.NO", value: "count" },
                    { text: "Learner", value: "Learner" },
                    { text: "Status", value: "status" },
                ],
                headers2: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Assessment Type",
                        align: "left",
                        sortable: false,
                        value: "assessmenttype",
                    },
                    {
                        text: "Evaluation Type",
                        align: "left",
                        sortable: false,
                        value: "evaluationtype",
                    },
                    {
                        text: "Evaluated Marks",
                        align: "left",
                        sortable: false,
                        value: "evaluated_marks",
                    },
                    {
                        text: "Converted Marks",
                        align: "left",
                        sortable: false,
                        value: "converted_marks",
                    },
                    {
                        text: "Passing Marks %",
                        align: "left",
                        sortable: false,
                        value: "passing_marks",
                    },
                    {
                        text: "Action",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                ],
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Semester",
                        align: "center",
                        sortable: false,
                        value: "semester",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "divisionoffering",
                    },
                    {
                        text: "Student",
                        align: "center",
                        sortable: false,
                        value: "crs_off_learner",
                    },
                    {
                        text: "Mark Entry Type",
                        align: "center",
                        sortable: false,
                        value: "coursemarksentrytype",
                    },
                    {
                        text: "Course Type",
                        align: "center",
                        sortable: false,
                        value: "coursetype",
                    },
                    {
                        text: "Grading Scheme",
                        align: "center",
                        sortable: false,
                        value: "gradingscheme",
                    },
                    {
                        text: "Assessment Scheme",
                        align: "center",
                        sortable: false,
                        value: "courseassessmentscheme",
                    },
                    {
                        text: "Action",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                ],
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "PRN No",
                        align: "center",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        align: "center",
                        sortable: false,
                        value: "name",
                    },
                ],
            };
        },
        methods: {
            async importMarksEntry() {
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("sem", this.scheme_details[0].semester_id);
                formData.append("coff_id", this.scheme_details[0].courseoffering_id);
                formData.append("ay", this.scheme_details[0].academicyear_id);
                formData.append("div_off", this.scheme_details[0].divisionoffering_id);
                formData.append("coff_inst", this.scheme_details[0].courseOfferingInstructor_id);
                formData.append("assd_id", this.scheme_details[0].ass_det_id);
                formData.append("std", this.scheme_details[0].standard_id);
                formData.append("courseAssessmentScheme", this.scheme_details[0].courseAssessmentScheme);
                formData.append("rubricsScheme", this.rubricsScheme);
                this.uploading = true;
                try {
                    const res = await axios.post("/Examination/importAssesmentMarksEntry", formData);
                    if (res.data.flag == "YES") {
                        this.statuslist = res.data.failstatuslist;
                        this.success_list = res.data.success_status_list;
                        this.showSnackbar("#4caf50", " Marks Save Successfully...");
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    }
                    this.uploading = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.uploading = false;
                } finally {
                    this.uploading = false;
                }
            },
            exportTableToCSV(filename) {
                //declare a JavaScript variable of array type
                if (this.rubricsScheme == "YES") {
                    var csv = [];
                    var rows = document.querySelectorAll("#example1  tr");
                    var rows2 = document.getElementById("example1");
                    //merge the whole data in tabular form
                    for (var i = 0; i < rows.length; i++) {
                        var row = [],
                            cols = rows[i].querySelectorAll("td, th");
                        for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
                        csv.push(row.join(","));
                    }
                    //call the function to download the CSV file
                    this.downloadCSV(csv.join("\n"), filename);
                } else {
                    var csv = [];
                    var rows = document.querySelectorAll("#example  tr");
                    var rows2 = document.getElementById("example");
                    //merge the whole data in tabular form
                    for (var i = 0; i < rows.length; i++) {
                        var row = [],
                            cols = rows[i].querySelectorAll("td, th");
                        for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
                        csv.push(row.join(","));
                    }
                    //call the function to download the CSV file
                    this.downloadCSV(csv.join("\n"), filename);
                }
            },
            downloadCSV(csv, filename) {
                var csvFile;
                var downloadLink;

                //define the file type to text/csv
                csvFile = new Blob([csv], { type: "text/csv" });
                downloadLink = document.createElement("a");
                downloadLink.download = filename;
                downloadLink.href = window.URL.createObjectURL(csvFile);
                downloadLink.style.display = "none";

                document.body.appendChild(downloadLink);
                downloadLink.click();
            },
            deletemarkentry(ass_det_id, courseoffering_id, courseAssessmentScheme) {
                if (!confirm("Are you sure you want to delete mark entry...?")) {
                    return;
                } else {
                    if (!confirm("Are you sure you want to delete mark entry...?")) {
                        return;
                    }
                }
                const data = {
                    courseoffering_id: courseoffering_id,
                    ass_det_id: ass_det_id,
                    courseAssessmentScheme: courseAssessmentScheme,
                    crs_off_learner: this.crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                    divisionoffering_id: this.divisionoffering_id,
                    crs_inst_id: this.crs_inst_id,
                };
                axios
                    .post("/Examination/deleteAssesmentSchemeMarkEntry", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Deleted Successfully"); // show snackbar on success
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            assesmentschememarkentry(ass_det_id, courseoffering_id, courseAssessmentScheme) {
                this.scheme_details = [];
                this.rubricsScheme = null;
                this.mark_entry_type = null;
                this.remarks_list = [];
                this.rubric_list = [];
                const data = {
                    courseoffering_id: courseoffering_id,
                    ass_det_id: ass_det_id,
                    courseAssessmentScheme: courseAssessmentScheme,
                    crs_off_learner: this.crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                    divisionoffering_id: this.divisionoffering_id,
                    crs_inst_id: this.crs_inst_id,
                };
                axios
                    .post("/Examination/assesmentschememarkentry", data)
                    .then((res) => {
                        this.scheme_details = res.data.scheme_details;
                        this.rubricsScheme = res.data.rubricsScheme;
                        this.mark_entry_type = res.data.mark_entry_type;
                        this.remarks_list = res.data.remarks_list;
                        this.grading_mark_entry = res.data.grading_mark_entry;
                        if (this.rubricsScheme == "YES") {
                            this.rubric_list = res.data.rubric_list;
                        }
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            getscheme_info(
                courseassessmentscheme_id,
                coff_id,
                crs_off_learner,
                divisionoffering_id,
                crs_inst_id,
                grade_details
            ) {
                this.ass_scheme_deatils_list = [];
                this.crs_off_learner = crs_off_learner;
                this.divisionoffering_id = divisionoffering_id;
                this.crs_inst_id = crs_inst_id;
                this.grade_details = grade_details;
                const data = {
                    courseassessmentscheme_id: courseassessmentscheme_id,
                    coff_id: coff_id,
                    crs_off_learner: this.crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                    divisionoffering_id: this.divisionoffering_id,
                    crs_inst_id: this.crs_inst_id,
                };
                axios
                    .post("/Examination/get_scheme_info", data)
                    .then((res) => {
                        this.ass_scheme_deatils_list = res.data.ass_scheme_deatils_list;
                        this.dialog_scheme = true;
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            get_learners(crs_off_learner) {
                const data = {
                    crs_off_learner: crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/get_learners_data", data)
                    .then((res) => {
                        this.learners = res.data.learners;
                        this.dialog = true;
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            getInstCourse() {
                this.loader = true;
                const data = {
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/examination/getInstCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.instrructor_course_list = res.data.instrructor_course_list;
                            this.loader = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered.."); // show snackbar
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        //stop loader
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                (this.ay_list = []), (this.semester_list = []);
                this.sem = null;
                (this.ay = null), (this.instrructor_course_list = []);
                axios
                    .post("/examination/offerAssessmentScheme")
                    .then((res) => {
                        this.assessment_scheme_list = res.data.assessment_scheme_list;
                        this.ay_list = res.data.ay_list;
                        this.semester_list = res.data.semester_list;
                        this.assessment_offer_list = res.data.assessment_offer_list;
                        this.allow_reexam_marks_entry = res.data.allow_reexam_marks_entry;
                        if (res.data.is_admin !== undefined) {
                this.is_admin = res.data.is_admin;
            }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
        },
        mounted() {
            this.org_id = localStorage.getItem("EPS-tenant");
            this.onload();
        },
    };
</script>
<style scoped>
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }

    /* Tabs container */
    .v-tabs {
        border-radius: 12px;
        overflow: visible;
    }

    /* Default tab */
    .v-tab {
        opacity: 0.7;
        font-weight: 500;
        transition: all 0.3s ease;
    }

    /* Hover effect */
    .v-tab:hover {
        opacity: 1;
        transform: translateY(-2px);
    }

    /* Active/Selected tab */
    .v-tab--active {
        opacity: 1 !important;
        font-weight: 700 !important;
        background: #ffffff !important;
        color: #1976d2 !important;
        border-radius: 10px 10px 0 0;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        transform: translateY(-3px);
        z-index: 2;
    }

    /* Active tab text */
    .v-tab--active .v-btn__content {
        font-size: 15px;
        font-weight: 700;
    }

    /* Slider */
    .v-tabs-slider {
        height: 4px !important;
        border-radius: 4px;
    }

    /* Inactive tabs */
    .v-tab:not(.v-tab--active) {
        background: rgba(255, 255, 255, 0.15);
        color: rgba(255, 255, 255, 0.8);
    }
    .yellow-card {
        font-size: 15px;
        background: #bad4e545;
        border-radius: 20px;
        padding: 20px;
        border-left: 5px solid #04456fff;
    }
</style>
